import { render, staticRenderFns } from "./OdgovorSingle.vue?vue&type=template&id=07133671&scoped=true&"
import script from "./OdgovorSingle.vue?vue&type=script&lang=js&"
export * from "./OdgovorSingle.vue?vue&type=script&lang=js&"
import style0 from "./OdgovorSingle.vue?vue&type=style&index=0&id=07133671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07133671",
  null
  
)

export default component.exports